// File: assets/sidebar-fix.js.liquid

(function($) {
  if (!window.location.pathname.includes('/products/')) return;

  // Patch the Sidebar.prototype.init directly to prevent overwrite and fix early unbinding
  theme.SidebarSection = (function() {
    function Sidebar() {
      this.init();

      $(selectors.mobileMenuTrigger).on(
        'click',
        function(evt) {
          var $mobileMenu = $(evt.target).closest(selectors.mobileMenuTrigger);
          evt.preventDefault();
          $mobileMenu.toggleClass('open');
          $(selectors.siteNav).slideToggle(400, function() {
            $(selectors.submenuParent)
              .has(selectors.expandedSubmenus)
              .hideSubmenu(0);
          });
        }.bind(this)
      );
    }

    Sidebar.prototype = _.assignIn({}, Sidebar.prototype, {
      init: function() {
        $(selectors.submenuTrigger).off('click').on('click', function(e) {
          var $trigger = $(this);
          var $parent = $trigger.parent(selectors.submenuParent);
          var isLink = $trigger.attr('href') && $trigger.attr('href') !== '#';
          var shouldExpand = $trigger.hasClass(classes.navExpand);

          if (isLink && !shouldExpand) return; // Let normal links work unless it's expandable

          e.preventDefault();

          if (shouldExpand) {
            $(selectors.activeSubmenu).removeClass(classes.activeSubmenu);

            $parent
              .find(selectors.collapsedSubmenus)
              .has(selectors.activeSubmenuParent)
              .parent(selectors.submenuParent)
              .not($parent)
              .showSubmenu(0);

            $parent.showSubmenu(400);

            $parent
              .siblings(selectors.submenuParent)
              .has(selectors.expandedSubmenus)
              .hideSubmenu(400);
          } else {
            $parent.hideSubmenu(400);
          }
        });
      }
    });

    $.fn.showSubmenu = function(duration) {
      this.children(selectors.submenuTrigger)
        .removeClass(classes.navExpand)
        .addClass(classes.navCollapse)
        .attr('aria-expanded', true)
        .children(selectors.submenuTriggerText)
        .text('-');

      this.children(selectors.submenu)
        .addClass(classes.activeSubmenu)
        .addClass(classes.expandedSubmenus)
        .removeClass(classes.collapsedSubmenus)
        .slideDown(duration)
        .attr('aria-hidden', false);

      return this;
    };

    $.fn.hideSubmenu = function(duration) {
      this.children(selectors.submenuTrigger)
        .removeClass(classes.navCollapse)
        .addClass(classes.navExpand)
        .attr('aria-expanded', false)
        .children(selectors.submenuTriggerText)
        .text('+');

      this.children(selectors.submenu)
        .addClass(classes.collapsedSubmenus)
        .removeClass(classes.expandedSubmenus)
        .slideUp(duration, function() {
          $(this)
            .find(selectors.expandedSubmenus)
            .not(this)
            .parent(selectors.submenuParent)
            .hideSubmenu(0);
        })
        .attr('aria-hidden', true);

      return this;
    };

    return Sidebar;
  })();
})(jQuery);
